export default {
      path: '/lvy-exposure',
      component: () => import('./LVYExposure'),
      meta: {
        title: '10倍曝光的好处',
        designWidth:750,
        expireIn: '',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'JSON'
        }
      }
    }
